@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (loadingComponent && getAnalysisService().isConsensusByType(decision_table?.framework.analysis_type)) {
  <app-consensus-new-proposal
    [proposal]="currentProposal"
    [framework]="framework"
    [decision_table]="decision_table"
    [showPrivateInfo]="showPrivateInfo"
    (addNewEvidenceEvent)="onClickAddNewEvidence($event)"
    (addAttachmentListEvent)="onClickAttachmentEventList($event)"
    (saveAndBackEvent)="saveAndBack($event)"
    (saveAndAddEvent)="saveAndAdd($event)"
  ></app-consensus-new-proposal>
}

@if (loadingComponent && getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)) {
  <app-multiobjective-new-proposal
    [proposal]="currentProposal"
    [framework]="framework"
    [decision_table]="decision_table"
    [current_organization]="current_organization"
    [showPrivateInfo]="showPrivateInfo"
    (addNewEvidenceEvent)="onClickAddNewEvidence($event)"
    (addAttachmentListEvent)="onClickAttachmentEventList($event)"
    (saveAndBackEvent)="saveAndBack($event)"
    (saveAndAddEvent)="saveAndAdd($event)"
    [isGeneratingPdf]="isGeneratingPdf"
    #pdfreport
  ></app-multiobjective-new-proposal>
}

@if (loadingComponent && getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)) {
  <app-multicriteria-new-proposal
    [proposal]="currentProposal"
    [framework]="framework"
    [decision_table]="decision_table"
    [showPrivateInfo]="showPrivateInfo"
    (addNewEvidenceEvent)="onClickAddNewEvidence($event)"
    (addAttachmentListEvent)="onClickAttachmentEventList($event)"
    (saveAndBackEvent)="saveAndBack($event)"
    (saveAndAddEvent)="saveAndAdd($event)"
  ></app-multicriteria-new-proposal>
}


<div style="
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;">

  @if (currentProposal?.criteria?.length > 0 && isEnel()) {
    <div class="print-button text-center mb-3"
      (click)="savePDF()">
      <span>
        <button mat-icon-button class="ml-auto">
          <mat-icon>print</mat-icon>
        </button>
      </span>
    </div>
  }

  @if (!currentProposal.anonymous_survey_enabled && answered()) {
    <div class="anonymize-button"
      (click)="toggleAnonymousProposalInfo()">
      @if (showPrivateInfo) {
        <span>{{ 'generic.hide-private-data' | translate }}</span>
      }
      @if (!showPrivateInfo) {
        <span>{{ 'generic.show-private-data' | translate }}</span>
      }
    </div>
  }
</div>

